// extracted by mini-css-extract-plugin
module.exports = {"howItWorks":"HowItWorks_howItWorks__QmRiN","step":"HowItWorks_step__E-KIE","number":"HowItWorks_number__-BhN-","mustRegister":"HowItWorks_mustRegister__GUkJh"};